<template>
  <v-app>
      <v-app-bar app color="#143878" height="auto" extension-height="0">
	  <v-container fluid class="pa-0">

	<v-row no-gutters justify="center" class="pt-14 pb-4">
      <v-col cols="16" class="text-center">
        <h1 class="white--text headline font-weight-bold">
          PSEA and accountability Venezuela
        </h1>
      </v-col>
    </v-row>

        <v-row>
          <v-col class="d-flex inner1">
            <v-img
              alt="CLEARGLOBAL"
              class="shrink mr-2"
              contain
              src="@/assets/logon.svg"
              width="45"
            />
            <v-spacer></v-spacer>
          
            <!-- Sector selection -->
            <v-select
              v-model="sectorValues"
              :items="sectors"
              multiple
              hide-details
              return-object
              v-on:change="changeSector"
            >
              <template v-slot:label><span class="label-white">{{ $i18n.t("Sectors") }}</span></template>
              <template  v-slot:prepend-item>
                <v-list-item>
                  <v-list-item-action>
                    <v-checkbox
                      :input-value="selectAllSectors"
                      value
                      v-on:change="handleSelectAllSectors"
                    ></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title v-text="'All'"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <template v-slot:selection="{ item, index }">
                <v-chip small color="#E7EAED" v-if="index < 1">
                  <span>{{ item.text }}</span>
                </v-chip>
                <span v-if="index === 1" class="white--text caption"
                  >(+{{ sectorValues.length - 1 }} others)</span
                >
              </template>
            </v-select>
          </v-col>
          <!-- end of Sector selection -->

          <!-- language selection -->
          <v-col class="d-flex" cols="5" sm="3">
            <v-select
              v-model="value"
              :items="headers"
              multiple
              hide-details
              return-object
              v-on:change="changeItem"
            >
              <template v-slot:label><span class="label-white">{{ $i18n.t("languages") }}</span></template>
              <template v-slot:selection="{ item, index }">
                <v-chip small color="E7EAED" v-if="index < 1">
                  <span>{{ item.text }}</span>
                </v-chip>
                <span v-if="index === 1" class="white--text caption"
                  >(+{{ value.length - 1 }} others)</span
                >
              </template>
            </v-select>
          </v-col>
          <!-- end of language selection -->

          <v-col class="d-flex resmedia " cols="7" sm="3" >
            <v-text-field
        
              v-model="search"
              clearable
              
              single-line
              class="mx-3 "
              hide-details
              flat
              color="white"
            > 
            <template v-slot:prepend-inner>
    <v-icon color="white">search</v-icon>
  </template>
              <template v-slot:label ><span class="label-white">{{ $i18n.t("search") }}</span></template>
            </v-text-field>
          </v-col>
     </v-row>
     <v-row>
 <v-col class="d-flex resmedia " cols="2" sm="3" >
	  <v-dialog v-model="dialog" scrollable width="max-content">
        <template v-slot:activator="{ on }">
          <v-icon color="white" v-on="on">info</v-icon>
        </template>
        <v-card>
          <v-card-title>{{ this.$i18n.t("info_about_title") }}</v-card-title>
          <v-card-text style="width: 100%">
            <About />
          </v-card-text>
          <v-card-actions>
            <v-btn color="#FFFFFF" text @click="dialog = false">{{
              this.$i18n.t("dialog_close")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

</v-col>

        </v-row>
      </v-app-bar>

    <v-main app>
      <v-hover v-slot:default="{ hover }">
        <v-data-table
          dense
          light
          :headers="selectedHeaders"
          :items-per-page="10"
          :expanded.sync="expanded"
          :expand-icon="''"
          show-expand
          item-key="id"
          :items="filteredData"
          @click:row="expandRow"
          class="elevation-1"
          :single-expand="true"
          :disable-sort="false"
          :search="search"
          :custom-filter="filterData"
          
          
        >


         <template v-for="(header, index) in selectedHeaders" v-slot:[`header.${header.value}`]="{ header }">
           <span :key="index">
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-if="header.icon > ''" icon color="grey lighten-2"
          v-bind="attrs"
          v-on="on">
                 <v-icon class='no-rotate' @click.stop x-small color="pink">{{ header.icon }}</v-icon>
              </v-btn>
               {{ header.text }}
      </template>
      <span>Click on a term to listen.</span>
    </v-tooltip>
           </span>
  </template>   
          <template
            v-for="(header, index) in selectedHeaders"
            v-slot:[`item.${header.value}`]="{ item }"
            
          >
          
            <span :key="index" :data-lang="header.value">{{
              header.value
                .split(".")
                .reduce((p, c) => (p && p[c]) || null, item)
            }}</span>
          </template>

          <template v-slot:top="{ pagination, options, updateOptions }">
            <v-data-footer
              :pagination="pagination"
              :options="options"
              @update:options="updateOptions"
              items-per-page-text="$vuetify.dataTable.itemsPerPageText"
            />
            <div class="wrapper-scroll" @scroll="scrollTop($event)">
              <div ref="scrollTop" class="scroll-top"></div>
            </div>
          </template>

          <template
            v-slot:item.data-table-expand="{ expand, isExpanded, item }"
          >
            <div
              v-if="item.Subterms && item.Subterms.length > 0"
              class="d-flex"
              @click="expand(!isExpanded)"
              style="align-items: center"
            >
              <v-icon v-if="isExpanded">keyboard_arrow_up</v-icon>
              <v-icon v-if="!isExpanded">keyboard_arrow_down</v-icon>
              <span>({{ item.Subterms.length }})</span>
            </div>
          </template>
          

          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <v-data-table
                :headers="headers"
                :items="item.Subterms"
                @click:row="expandSubRow"
                :items-per-page="7"
                :disable-sort="true"
                class="elevation-1"
              >
                <template v-slot:item.Sector="{ item, value }">
                  <div
                    v-if="value.length > 0"
                    @click="openRowDetailsModal(item, 'Sector')"
                    style="white-space: nowrap"
                  >
                    <v-chip small color="#E8991C">
                      <span>{{ value[0].term }}</span>
                    </v-chip>
                    <span
                      v-if="value.length > 1"
                      class="black--text caption ml-2"
                      >(+{{ value.length - 1 }})</span
                    >
                  </div>
                </template>
              </v-data-table>
            </td>
          </template>

          <template v-slot:item.Sector="{ item, value }">
            <div
              v-if="value.length > 0"
              @click="openRowDetailsModal(item, 'Sector')"
              style="white-space: nowrap"
            >
              <v-chip small color="#E8991C">
                <span>{{ value[0].term }}</span>
              </v-chip>
              <span v-if="value.length > 1" class="black--text caption ml-2"
                >(+{{ value.length - 1 }})</span
              >
            </div>
          </template>
        </v-data-table>
      </v-hover>
    </v-main>
    <v-row justify="center"></v-row>
    <v-footer color="#143878">
      <span class="white--text">&copy; 2026 CLEAR Global
        <v-btn
          x-small
          icon
          outlined
	  color="white"
          href="https://creativecommons.org/licenses/by-nc-sa/3.0/us/"
          target="_blank">
          cc
        </v-btn></span>
      <v-spacer></v-spacer>
      <v-btn x-small color="secondary"  href="https://form.asana.com/?k=5AXoSRr3_Xp5r4ztumlgcA&d=170818793545926" target="_blank">Feedback</v-btn>
      <v-dialog v-model="dialog" scrollable width="max-content">
        <template v-slot:activator="{ on }">
          <v-icon color="white" v-on="on">info</v-icon>
        </template>
        <v-card>
          <v-card-title>{{ this.$i18n.t("info_about_title") }}</v-card-title>
          <v-card-text style="width: 100%">
            <About />
          </v-card-text>
          <v-card-actions>
            <v-btn color="#143878" text @click="dialog = false">{{
              this.$i18n.t("dialog_close")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Removed persistent to close the dialog when clicking outside;For a glossary with multimedia  user will be forced to click the button-->

      <v-dialog v-model="row" scrollable width="80%"">
        <v-card>
          <v-card-title :class="['headline', 'grey', 'lighten-2', isRtl(lang)]">
            {{ term }}
          </v-card-title>
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-header>
                <v-icon color="#143878">info</v-icon>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <span class="font-weight-bold"
                  >{{ this.$i18n.t("dialog_sector") }}:</span
                >
                <v-spacer></v-spacer>
                <v-chip-group column>
                  <v-chip
                    color="rgba(0, 0, 0, 0.54)"
                    v-for="sector in selectedRowSectors"
                    :key="sector.term"
                  >
                    {{ sector.term }}
                  </v-chip>
                </v-chip-group>

                <v-spacer></v-spacer>

                <v-spacer></v-spacer>
                <span v-if="dictionary" class="font-weight-bold"
                  >{{ this.$i18n.t("dialog_dictionary") }}:</span
                >
                <v-spacer></v-spacer>
                {{ dictionary }}

                <v-spacer></v-spacer>
                <span v-if="abbreviation" class="font-weight-bold"
                  >{{ this.$i18n.t("dialog_abbreviation") }}:</span
                >
                <v-spacer></v-spacer>
                {{ abbreviation }}

                <v-spacer></v-spacer>
                <span v-if="partofspeech" class="font-weight-bold"
                  >{{ this.$i18n.t("dialog_partofspeech") }}:</span
                >
                <v-spacer></v-spacer>
                {{ partofspeech }}

                <v-spacer></v-spacer>
                <span v-if="alternative" class="font-weight-bold"
                  >{{ this.$i18n.t("dialog_alternative") }}:</span
                >
		{{ alternative }}

                <v-spacer></v-spacer>
		<span v-if="usagenote" class="font-weight-bold"
                  >{{ this.$i18n.t("dialog_usagenote") }}:</span
                >
                <v-spacer></v-spacer>
                {{ usagenote }}

                <v-spacer></v-spacer>
                <span v-if="definition" class="font-weight-bold"
                  >{{ this.$i18n.t("dialog_definition") }}:</span
                >
                <v-spacer></v-spacer>
                <div :class="isRtl(lang)">{{ definition }}</div>

                <v-spacer></v-spacer>
                <span v-if="explanation" class="font-weight-bold"
                  >{{ this.$i18n.t("dialog_explanation") }}:</span
                >
                <v-spacer></v-spacer>
                {{ explanation }}

                <v-spacer></v-spacer>

                <span v-if="source" class="font-weight-bold">
                  {{ this.$i18n.t("dialog_source") }}:
                </span>

                <v-spacer></v-spacer>
                <span v-if="source">{{ source }}</span>
                <v-spacer></v-spacer>

                <v-btn
                  v-if="sourcelink"
                  x-small
                  outlined
                  :href="`${sourcelink}`"
                  target="_blank"
                >
                  {{ source }}
                </v-btn>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel v-if="picturecount">
              <v-expansion-panel-header>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-badge color="grey" :content="picturecount" inline>
                      <v-icon
                        color="#143878"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        >mdi-folder-image</v-icon
                      >
                    </v-badge>
                  </template>
                  <span>{{ this.$i18n.t("dialog_tooltip_img") }}</span>
                </v-tooltip>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-spacer></v-spacer>
                <v-carousel v-if="picture">
                  <v-carousel-item
                    v-for="(item, i) in picture"
                    :key="i"
                    :src="'./library/pictures/' + item.url"
                    reverse-transition="fade-transition"
                    transition="fade-transition"
                  ></v-carousel-item>
                </v-carousel>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel v-if="vidcount">
              <v-expansion-panel-header>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-badge color="grey" :content="vidcount" inline>
                      <v-icon
                        color="#143878"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        >mdi-video</v-icon
                      >
                    </v-badge>
                  </template>
                  <span>{{ this.$i18n.t("dialog_tooltip_vid") }}</span>
                </v-tooltip>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-spacer></v-spacer>
                <template>
                  <span v-for="(value, index) in vid" v-bind:key="index">
                    <div class="player-container">
                      <vue-core-video-player
                        :src="value.url"
                        :title="value.title"
                        :autoplay="false"
                      ></vue-core-video-player>
                    </div>
                  </span>
                </template>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel v-if="audiocount">
              <v-expansion-panel-header>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-badge color="grey" :content="audiocount" inline>
                      <v-icon
                        color="#143878"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        >mdi-volume-high</v-icon
                      >
                    </v-badge>
                  </template>
                  <span>{{ this.$i18n.t("dialog_tooltip_audio") }}</span>
                </v-tooltip>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-spacer></v-spacer>
                <v-carousel :show-arrows="false">
                  <v-carousel-item
                    v-for="(value, index) in audio"
                    v-bind:key="index"
                  >
                    <v-divider></v-divider>
                    <v-container class="grey lighten-5">
                      <v-chip class="text-center .col-6 .col-md-4">
                        <span class="white--text"
                          >{{ index }}/{{ audiocount }}</span
                        >
                      </v-chip>
                      <v-spacer></v-spacer>
                      <v-row>
                        <v-col>
                          <span class="font-weight-bold text-center black--text"
                            >Language:</span
                          >
                          <v-spacer></v-spacer>
                          <span class="font-weight-regular black--text">
                            {{ lang }}
                          </span>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <span class="font-weight-bold text-center black--text"
                            >Term:</span
                          >
                          <v-spacer></v-spacer>
                          <span class="font-weight-regular black--text">
                            {{ term }}
                          </span>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-row>
                      <v-spacer></v-spacer>

                      <v-row >
                        <v-col >
                          <av-waveform
                            audio-class="audioclass"
                            :audio-src="value.url"
                            :noplayed-line-color="waveformcolor"
							:canv-width="200"
                          ></av-waveform>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-carousel-item>
                </v-carousel>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#143878" text @click="row = false">{{
              this.$i18n.t("dialog_close")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <span :class="onlineDot"></span>
    </v-footer>
  </v-app>
</template>

<script>
import About from "@/views/About.vue";
import json from "@/assets/data/glossary.json";

export default {
  name: "App",
  components: { About },
  data() {
    return {
      id: "",
      publicPath: process.env.BASE_URL,
      glossary: json,
      search: "",
      value: [{ text: "Sectors", value: "Sector" }],
      expanded: [],
      selectedHeaders: [],
      dialog: false,
      row: false,
      term: "",
      rtl: "",
      lang: "",
      dictionary: "",
      definition: "",
      explanation: "",
      abbreviation: "",
      partofspeech: "",
      sourcelink: "",
      alternative: "",
      usagenote: "",
      source: "",
      library: "",
      picture: "",
      vid: "",
      audio: "",
      audiocount: "",
      picturecount: "",
      vidcount: "",
      waveformcolor: "#E8991C",
      selectedSectors: [],

      sectorValues: [],

      selectedRowSectors: [],

      sectors: [
        { text: this.$i18n.t("CCCM"), value: "CCCM" },
        { text: this.$i18n.t("Forms of harm and abuse"), value: "Formas de daño y abuso" },
        { text: this.$i18n.t("Gender and identity"), value: "Género e identidad" },
        {
          text: this.$i18n.t("Gender and identity > Gender Based Violence"),
          value: "Violencia basada en el género",
        },
        {
          text: this.$i18n.t("Norms, Policies and Documentation"),
          value: "Normas, políticas y documentación",
        },
        { text: this.$i18n.t("Organizations"), value: "Organizaciones" },
        { text: this.$i18n.t("People, Individuals"), value: "Personas, individuos" },
        { text: this.$i18n.t("Protection"), value: "Protección" },
        { text: this.$i18n.t("Safeguarding Procedures"), value: "Procedimientos de salvaguardia" },
	{ text: this.$i18n.t("Nutrition"), value: "Nutrición" },
	{ text: this.$i18n.t("Health"), value: "Salud" },
	{ text: this.$i18n.t("Logistics"), value: "Logística" },
	{ text: this.$i18n.t("General Programming"), value: "Programación general" },
	{ text: this.$i18n.t("Food Security"), value: "Seguridad alimentaria" },
      ],
      headers: [
        { text: this.$i18n.t("Sectors"), value: "Sector", disabled: true },
	{ text: this.$i18n.t("Spanish (Latin America)"), value: "SpanishLa.term" },
	{ text: this.$i18n.t("Pemon"), value: "Pemon.term" },
	{ text: this.$i18n.t("Warao"), value: "Warao.term" },
	{ text: this.$i18n.t("Wayuu"), value: "Wayuu.term" },
        { text: this.$i18n.t("English"), value: "English.term" },
		
      ],

      panel: 0,
      lang: "",
      languages: [{ text: "Spanish (Latin America)", value: "en" }],     
      sheet: false,
      onLine: navigator.onLine,
      onlineDot: navigator.onLine === true ? "online" : "offline",
      selectAllSectors: true,
    };
  },
  methods: {
    filterData(value, search, item) {
      const keys = [
        "English",
        "SpanishLa",
		"Warao",
		"Wayuu",
		"Pemon",
      ];
      if (!search) return true;
      const regex = new RegExp(search, "gi");
      return keys.some((key) => regex.test(item[key].term));
    },

    expandRow(item) {
      //Get the onject entry based on user click
      var data = json.glossary;

      var filteredObject = data.find(
        (glossaryItem) => glossaryItem.id === item.id
      );

      let lang = null
      if (event.target.tagName === 'SPAN') {
        lang = event.target.dataset.lang?.split('.')[0]
      } else if (event.target.tagName === 'TD') {
        const span = event.target.querySelector('span')
        lang = span?.dataset.lang?.split('.')[0]
        console.log(lang)
      }
      const resource = item[lang]
      this.term = resource.term;
      this.abbreviation = resource.abbreviation;
      this.partofspeech = resource.partofspeech;
      this.rtl = resource.rtl;
      this.lang = lang
      this.definition = resource.definition;
      this.dictionary = resource.dictionary;
      this.explanation = resource.explanation;
      this.alternative = resource.alternative;
      this.usagenote = resource.usagenote;
      this.source = resource.source;
      this.sourcelink = resource.sourcelink;
      this.selectedRowSectors = item.Sector;

      this.audio = resource.library.audio;
      this.picture = resource.library.picture;
      this.vid = resource.library.video;
      this.library = resource.library;

      this.audiocount = Object.keys(resource.library.audio).length;
      this.picturecount = Object.keys(resource.library.picture).length;
      this.vidcount = Object.keys(resource.library.video).length;
      this.row = true;
    },
    expandSubRow(item) {
      const parentItem = this.expanded[0];
      //Get the onject entry based on user click
      var data = parentItem.Subterms;

      var filteredObject = data.find((subterm) => subterm.id === item.id);

      //Get objects in the selected term
      var term = event.target.innerHTML;
      function objfilter(object, result, key, value) {
        if (object.hasOwnProperty(key) && object[key] == value) {
          result.push(object);
        } else {
          for (var i = 0; i < Object.keys(object).length; i++) {
            if (
              typeof object[Object.keys(object)[i]] === "object" &&
              object[Object.keys(object)[i]] !== null
            ) {
              objfilter(object[Object.keys(object)[i]], result, key, value);
            }
          }
        }
      }
      var result = [];
      objfilter(filteredObject, result, "term", term);

      var resource = result[0];
      this.term = resource.term;
      this.abbreviation = resource.abbreviation;
      this.partofspeech = resource.partofspeech;
      this.definition = resource.definition;
      this.dictionary = resource.dictionary;
      this.explanation = resource.explanation;
      this.alternative = resource.alternative;
      this.usagenote = resource.usagenote;
      this.source = resource.source;
      this.selectedRowSectors = item.Sector;

      this.audio = resource.library.audio;
      this.picture = resource.library.picture;
      this.vid = resource.library.video;
      this.library = resource.library;

      this.audiocount = Object.keys(resource.library.audio).length;
      this.picturecount = Object.keys(resource.library.picture).length;
      this.vidcount = Object.keys(resource.library.video).length;
      this.row = true;
    },
    openRowDetailsModal(item, key) {
      var terms = item[key];

      this.term = terms[0].term;
      this.definition = terms[0].definition;
      this.selectedRowSectors = item.Sector;

      this.row = true;
    },
    changeSector(event) {
      this.selectAllSectors = false;
      this.selectedSectors = event.map((item) => item.text);
    },

    handleSelectAllSectors(event) {
      if (event === true) {
        this.sectorValues = [];
        this.selectedSectors = this.sectors.map((item) => item.text);
      }
    },

    changeLang(event) {
      this.$i18n.locale = event.value;
      this.$vuetify.lang.current = event.value;
      this.sheet = !this.sheet;
      this.json = null;
    },
    changeItem(event) {
      var langs = [];

      for (var i = 0; i < event.length; i++) {
        langs.push(event[i].text);
      }

      //Google Analytics
      this.$gtag.event("Selected Language Combinations", {
        event_category: "Lang",
        event_label: langs,
        value: "test offline",
        // event_label: "Language(s)",
        //value: langs
      });
    },
    updateOnlineStatus(e) {
      const { type } = e;

      this.onLine = type === "online";
      this.onlineDot = type;
    },
    getColor(item) {
      if (item == "Covid-19") return "red";
      else if (item == "Health") return "orange darken-1";
      else if (item == "Emergency") return "red darken-2";
      else if (item == "Education") return "blue";
      else if (item == "Protection") return "green";
      else return "";
    },
    isRtl(lang) {
      return ['Arabic', 'Kurdish_Badini', 'Kurdish_Kurmanji', 'Kurdish_Sorani' ].includes(lang) ? 'text-rtl' : 'text-ltr'
    },
    scrollTop(event) {
      let scrollTable = document.querySelector('.v-data-table__wrapper');
      scrollTable.scrollLeft = event.target.scrollLeft;
    }
  },
  watch: {
    value(val) {
      this.selectedHeaders = val;
    },

    selectAllSectors(val) {},
    onLine(val) {
      if (val) {
        this.showBackOnline = true;
      } else {
        this.showBackOnline = false;
      }
    },
    row(val) {
      if (!val) {
        //Reset the audio when modal is closed
        this.audio = "";
        //Close the panel
        this.panel = 0;
        //Pause the video when modal is closed
        var video = document.getElementsByTagName("video")[0];

        //Prevent throwing an error when the video has not been played
        if (typeof video !== "undefined") {
          video.addEventListener(
            "seeking",
            function () {
              if (video.paused) {
                video.pause();
              } else {
                video.pause();
              }
            },
            false
          );

          video.currentTime = 0;
        }

        //Pause the audio when modal is closed
        /*
        var audio = document.getElementsByTagName("audio")[0];
        audio.addEventListener(
          "seeking",
          function() {
            if (!audio.paused) {
              audio.pause();
            } else {
              audio.pause();
            }
          },
          false
        );

        audio.currentTime = 0;
        */
      }
    },
  },
  computed: {
    //Sector Dropdown - Filter data based on selected sector
    filteredData() {
      var sectors = this.selectedSectors;

      if (this.selectAllSectors) {
        return json.glossary;
      } else {
        var data = json.glossary;
        var filtered_glos = [];

        filtered_glos = data.filter(function (item) {
          let hasSector = false;
          if (sectors.length > 0) {
            item.Sector.forEach(({ term }) => {
              if (sectors.includes(term)) {
                hasSector = true;
              }
            });
          } else {
            hasSector = true;
          }

          return hasSector;
        });
        return filtered_glos;
      }
    },
  },
  created() {
    this.selectedHeaders = this.headers;
  },
  mounted() {
    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);
    var wrapperTable = document.querySelector('.v-data-table__wrapper');
    window.addEventListener('load', () => {

      let wrapperScroll = document.querySelector('.wrapper-scroll');
      let scrollTop = this.$refs.scrollTop;

      wrapperScroll.scrollLeft = wrapperTable.scrollLeft;
      scrollTop.style.width = wrapperTable.scrollWidth + 'px';
    })
  },
  beforeDestroy() {
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);
  },
};
</script>
<style lang="scss">
* {
    -webkit-font-smoothing: antialiased;

    &::-webkit-scrollbar-track {
      background-color: transparent;
    }
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background-color: transparent;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 3px;
      background-color: #143878;
    }
}
.application {
  font-family: "Rubik";
}
.v-data-table-header th {
  white-space: nowrap;
}
.v-sheet.v-app-bar.v-toolbar {
  height: 17vh !important;
}
.v-toolbar__content {
  height: 17vh !important;
}
.tbody tr:nth-of-type(even) {
  background-color:#e1eaf2 !important;
  cursor: pointer;
}
tbody tr:nth-of-type(odd) {
  background-color:#E7EAED !important;
  cursor: pointer;
}
.v-data-footer__pagination {
  margin-right: 1px !important;
  margin-left: 1px !important;
}
.v-application--is-ltr .v-data-footer__select .v-select {
  margin-top: 1px !important;
  margin-bottom: 5px !important;
}
.online {
  height: 10px;
  width: 10px;
  background-color: #11ed83;
  border-radius: 50%;
  display: inline-block;
}
.offline {
  height: 10px;
  width: 10px;
  background-color: #d61106;
  border-radius: 50%;
  display: inline-block;
}
.nav {
  background-color: "#143878";
}
.align-right {
  text-align: right;
}
.v-main {
  padding: 75px 0 0 !important;
}
.theme--light.v-data-table .v-data-footer {
  border-top: none !important;
}
.wrapper-scroll {
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
}
.wrapper-scroll .scroll-top {
  height: 20px;
}
@media only screen and (max-width: 380px) {
.v-sheet.v-app-bar.v-toolbar {
    height: 27vh !important;
  }
  .v-toolbar__content {
    display: block !important;
  }
  .v-main {
    padding: 27vh 0px !important;
  }
  .wrapper-scroll {
    display: none;
  }
}
.v-data-table__expanded > td[colspan="8"] {
  padding: 0px !important;
}
.v-data-table__expanded {
  padding: auto;
}
.text-start {
  padding: 0 16px;
}
.label-white {
  color: rgb(255, 255, 255);
  font-weight: bolder
}
.v-data-table__mobile-row__cell {
  font-weight: 300;
}
.v-data-table-header-mobile {
  display: none !important;
}
.v-toolbar .v-input {
  padding-top: 10px !important;
}
.theme--light.v-input input {
    color: rgba(255, 255, 255, 1) !important;
}

.v-datatable thead th.column.sortable.asc .no-rotate {
    transform: none !important;
    opacity: 1 !important;
}

.v-datatable thead th.column.sortable.desc .no-rotate {
    transform: none !important;
    opacity: 1 !important;
}
</style>

